<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div class="w-full">
    <a
      :aria-label="$t('search.navigate-to', { label })"
      class="cursor-pointer text-sm flex flex-row justify-start items-center transition rounded-none lg:rounded-md py-1.5 mx-0 px-standard lg:-mx-1.5 lg:px-1.5"
      :class="{
        // '': position === 'top',
        'bg-ocean-100 text-ocean-700 font-semibold': isActive,
        'text-neutral-800 hover:text-ocean-700 hover:bg-ocean-100/50': !isActive,
      }"
      :href="href"
      @click.prevent="$emit('click', (linkType === 'route' ? { route: category?.route } : { navId: navId }))"
    >
      <span
        v-tippy="{
          placement: 'right',
          trigger: stickyOpen ? 'manual' : 'mouseenter',
        }"
        class="flex items-center justify-center w-6 h-6 mr-2"
        :content="label"
      >
        <fa
          v-if="icon || (position === 'side' && !stickyOpen)"
          :icon="['fal', icon || (position === 'side' && !stickyOpen ? 'file-lines' : '')]"
          class="fa-fw text-xl text-neutral-600"
        />
      </span>
      <span
        v-if="stickyOpen"
        class="line-clamp-1 flex-1"
      >
        {{ label }}
      </span>
      <span
        v-if="hasChildren && stickyOpen"
        class="flex items-center justify-center p-2 -m-2"
        @click.stop.prevent="toggleChildren"
      >
        <fa
          :icon="['fal', 'angle-down']"
          class="text-lg text-neutral-600 transition fa-fw"
          :class="{
            'fa-rotate-180': childrenOpen,
          }"
        />
      </span>
    </a>
    <div
      v-if="hasChildren && childrenOpen"
      class="space-y-1 my-1"
    >
      <vetster-dynamic-sticky-nav-link
        v-for="child in children"
        :key="child?.slug"
        :active-nav="activeNav"
        :label="child?.nav_title"
        :href="child?.route"
        :position="position"
        :sticky-open="stickyOpen"
        :nav-id="child?.slug"
        @click="$emit('click', { route: child?.route })"
      />
    </div>
  </div>
</template>

<script>
import { wrapHash } from '@/helpers/format';

export default {
  name: 'VetsterDynamicStickyNavLink',

  props: {
    linkType: {
      type: String,
      default: 'anchor',
    },
    activeNav: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    navId: {
      type: String,
      default: null,
    },
    position: {
      type: String,
      default: 'side',
    },
    stickyOpen: {
      type: Boolean,
      default: true,
    },
    category: {
      type: Object,
      default: () => ({}),
    },
    children: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['click'],

  data: () => ({
    childrenOpen: false,
  }),

  computed: {
    activeNavHash() {
      return wrapHash(this.activeNav);
    },
    navIdHash() {
      return wrapHash(this.navId);
    },
    isActive() {
      return this.activeNavHash === this.navIdHash || (!this.activeNavHash && this.navIdHash === '#pet-connection');
    },
    hasChildren() {
      return this.children?.length > 0;
    },
  },

  mounted() {
    // If the active nav on page load is a child or if the parent is active, open the children
    if (this.children?.length && this.activeNav) {
      this.childrenOpen = this.isActive || this.children.some((child) => this.activeNavHash === wrapHash(child.slug));
    }
  },

  methods: {
    toggleChildren() {
      if (this.hasChildren) {
        this.childrenOpen = !this.childrenOpen;
      }
    },
    wrapHash,
  },
};
</script>
